module.exports = __webpack_public_path__ + "static/img/33.2f10a05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/33.jpg
// module id = l8Zl
// module chunks = 1